<div  [ngClass]="dashboardTileType === 'total'  ? 'dashboardTile-Total' :  dashboardTileType === 'accepted' ? 'dashboardTile-Accepted' : dashboardTileType === 'declined' ? 'dashboardTile-Declined' : dashboardTileType === 'canceled' ? 'dashboardTile-Canceled' : dashboardTileType === 'completed' ? 'dashboardTile-Completed' : dashboardTileType === 'ready' ? 'dashboardTile-Ready' : '' ">

    <div class="dashboardTile-inner">
        <h1 class="txtorderCount">{{count}}</h1>
        <span class="txt-caption">{{dashboardTileType === 'total' ? 'Total Orders' : dashboardTileType === 'accepted' ? 'Accepted Orders' : dashboardTileType === 'declined' ? 'Declined Orders' : dashboardTileType === 'canceled' ? 'Canceled Orders' : dashboardTileType === 'completed' ? 'Completed Orders' : dashboardTileType === 'ready' ? 'Ready for pickup' : '' }}</span>
    </div>

    <div *ngIf="dashboardTileType === 'total' ">
        <img src="../../../../..//assets/icons/resturant.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>

    <div *ngIf="dashboardTileType === 'accepted' ">
        <img src="../../../../..//assets/icons/checklist.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>

    <div *ngIf="dashboardTileType === 'completed' ">
        <img src="../../../../..//assets/icons/check.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>

    <div *ngIf="dashboardTileType === 'ready' ">
        <img src="../../../../..//assets/icons/delivery.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>

    <div *ngIf="dashboardTileType === 'canceled'">
        <img src="../../../../..//assets/icons/close.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>
 

    <div *ngIf="dashboardTileType === 'declined'">
        <img src="../../../../..//assets/icons/declined.png" class="icon-tile" width="56px" alt="" loading="lazy"
        routerLink="/profile">
    </div>
 


</div>